import { useUsers } from '../../metodos/userContext';
import React, { useState, useEffect } from 'react';
import { solicitudesApi } from '../../services/api';
import { useHistorialCotizacionesModel } from '../../modelos/Solicitudes/modeloHistorialCotizaciones'; // Ajusta según tu estructura
import { formatearFechaCompleta , formatearFechaCorta} from '../../utils/utils'; // Importamos desde el archivo utils.js

const MisCotizaciones = () => {

  const {
    cotizaciones,
    cargandoCotizaciones,
    errorCotizaciones,
    hasMore,
    cargarCotizaciones,
    cargarMas,
  } = useHistorialCotizacionesModel();
  
  // Cargar primera página de cotizaciones
  useEffect(() => {
    cargarCotizaciones();
  }, []);
  
  //cargar cotizaciones de demas empresas
  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl font-bold mb-6">Mis Cotizaciones</h2>
      
      {errorCotizaciones && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {errorCotizaciones}
        </div>
      )}
      
      {cargandoCotizaciones && cotizaciones.length === 0 ? (
        <div className="flex justify-center my-8">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      ) : cotizaciones.length === 0 ? (
        <div className="text-center p-8 bg-gray-50 rounded-lg">
          <p className="text-gray-600">No has realizado cotizaciones aún.</p>
        </div>
      ) : (
        <div className="space-y-6">
          {cotizaciones.map((item, index) => (
            <div key={`${item.solicitudId}-${index}`} className="bg-white rounded-lg shadow p-6 border border-gray-200">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="text-xl font-semibold">
                    {item.solicitudData?.materia}
                  </h3>
                  <p className="text-sm text-gray-500">ID: {item.solicitudId}</p>
                </div>
                
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                <div className="space-y-2">
                <p><span className="font-medium text-gray-700">Servicio:</span> {item.solicitudData?.Servicio} </p>
                  <p><span className="font-medium text-gray-700">Resumen:</span> {item.solicitudData?.resumen} </p>
                  <p><span className="font-medium text-gray-700">Fecha de entrega:</span> {formatearFechaCompleta(item.solicitudData?.fechaentrega)}</p>
                  {item.solicitudData?.archivos && (
                    <p>
                      <span className="font-medium text-gray-700">Archivos:</span>{' '}
                      <a 
                        href={item.solicitudData.archivos} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline"
                      >
                        Ver archivos
                      </a>
                    </p>
                  )}
                </div>
                
                <div className={`p-4 rounded-md space-y-2 ${item.cotizacion === -1 ? 'bg-red-50' : 'bg-gray-50'}`}>
                  <h4 className="font-semibold">
                    {item.cotizacion === -1 ? 'Trabajo Rechazado' : 'Tu cotización'}
                  </h4>
                  
                  {item.cotizacion === -1 ? (
                    <p className="text-red-700 font-medium">Has rechazado esta solicitud</p>
                  ) : (
                    <p><span className="font-medium text-gray-700">Valor:</span> ${item.cotizacion || '0'}</p>
                  )}
                  
                  <p><span className="font-medium text-gray-700">
                    {item.cotizacion === -1 ? 'Fecha de rechazo:' : 'Fecha de cotización:'}
                  </span> {formatearFechaCorta(item.fechaconfirmacion)}</p>
                  
                  {(item.comentariocotizacion || item.cotizacion?.['Comentario Cotización']) && (
                    <div>
                      <p className="font-medium text-gray-700">
                        {item.cotizacion === -1 ? 'Motivo del rechazo:' : 'Comentario:'}
                      </p>
                      <p className={`text-sm p-2 rounded border mt-1 ${item.cotizacion === -1 ? 'bg-red-100 border-red-200' : 'bg-white border-gray-200'}`}>
                        {item.comentariocotizacion || item.cotizacion?.['Comentario Cotización']}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
          
          {hasMore && (
            <div className="text-center mt-8">
              <button
                onClick={cargarMas}
                disabled={cargandoCotizaciones}
                className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {cargandoCotizaciones ? (
                  <span className="flex items-center justify-center">
                    <span className="animate-spin h-4 w-4 mr-2 border-t-2 border-b-2 border-white rounded-full"></span>
                    Cargando...
                  </span>
                ) : (
                  'Cargar más'
                )}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );

};

export default MisCotizaciones;